const Deactivated = () => import("./pages/Deactivated.vue");
const ForgottenPassword = () =>
  import(/* webpackChunkName: "onBoarding" */ "./pages/ForgottenPassword");
const LandingLayout = () =>
  import(/* webpackChunkName: "onBoarding" */ "./layouts/LandingLayout");
const LandingSidebar = () =>
  import(
    /* webpackChunkName: "onBoarding" */ "./components/sidebars/LandingSidebar"
  );
const Login = () =>
  import(/* webpackChunkName: "onBoarding" */ "./pages/Login");
const NotFound = () =>
  import(/* webpackChunkName: "notFound" */ "./pages/NotFound");
const InPreparation = () =>
  import(/* webpackChunkName: "notFound" */ "./pages/InPreparation");
const PortfolioManager = () => import("./pages/PortfolioManager");
const Register = () =>
  import(/* webpackChunkName: "onBoarding" */ "./pages/Register");
const ResetPassword = () => import("./pages/ResetPassword");
const VerifyEmail = () => import("./pages/VerifyEmail");
import VueRouter from "vue-router";
import { pathPermissions } from "./utils/constants";
import { publicPath } from "../vue.config";
import store from "./store/index";

const routes = [
  {
    path: "/",
    components: {
      default: LandingLayout
    },
    children: [
      {
        path: "",
        name: "Login",
        components: {
          default: Login,
          sidebar: LandingSidebar
        }
      },
      {
        path: "/register",
        name: "Registration",
        components: {
          default: Register,
          sidebar: LandingSidebar
        }
      },
      {
        path: "/forgottenPassword",
        name: "ForgottenPassword",
        components: {
          default: ForgottenPassword,
          sidebar: LandingSidebar
        }
      },
      {
        path: "/fe/verify-register/:key",
        name: "VerifyRegistration",
        components: {
          default: VerifyEmail,
          sidebar: LandingSidebar
        }
      },
      {
        path: "/fe/verify-reset/:uid/:token",
        name: "VerifyReset",
        components: {
          default: ResetPassword,
          sidebar: LandingSidebar
        }
      },
      {
        path: "/deactivated",
        components: {
          default: Deactivated,
          sidebar: LandingSidebar
        },
        name: "Deactivated"
      }
    ]
  },
  {
    path: "/factorInvesting",
    component: InPreparation,
    name: "FactorInvesting"
  },
  {
    path: "/marketSentiment",
    component: InPreparation,
    name: "Market Sentiment"
  },
  {
    path: "/portfolioManager",
    component: PortfolioManager,
    name: "PortfolioManager"
  },
  {
    path: "*",
    component: NotFound
  }
];

const router = new VueRouter({ routes, mode: "history", base: publicPath });

router.beforeEach((to, from, next) => {
  const isOnNoAuthPage =
    [
      "Login",
      "Registration",
      "ForgottenPassword",
      "VerifyRegistration",
      "VerifyReset"
    ].indexOf(to.name) >= 0;

  const isOnGeneralyAccesiblePage =
    ["termsAndConditions", "privacyPolicy"].indexOf(to.name) >= 0;

  if (to.name === "Deactivated") {
    store.commit("deleteUser");
    window.$cookies.remove("accessToken");
    localStorage.removeItem("refreshToken");
    next();
  } else if (isOnGeneralyAccesiblePage) {
    store.commit("setIsInitializing", false);
    next();
  } else if (
    isOnNoAuthPage &&
    store.getters.getUser &&
    !store.getters.isLoggingOut
  ) {
    next({ name: "PortfolioManager" });
  } else if (store.getters.getUser) {
    if (store.getters.getInitStatus) {
      store.commit("setIsInitializing", false);
    }
    next();
  } else {
    if (window.$cookies.isKey("accessToken")) {
      store
        .dispatch("checkToken")
        .then(() => {
          const permissions = store.getters.getUser.permissions;
          const path = Object.keys(pathPermissions).find(p => to.path.includes(p));

          if (isOnNoAuthPage) {
            window.location.href = "/welcome";
          } else if (!isOnNoAuthPage && path && !permissions.includes(pathPermissions[path])) {
            window.location.href = "/welcome";
          } else {
            next();
          }
        })
        .catch(() => {
          window.$cookies.remove("accessToken");
          localStorage.removeItem("refreshToken");
          next({ name: "Login" });
        });
    } else {
      store.commit("setIsInitializing", false);
      if (isOnNoAuthPage) {
        next();
      } else {
        next({ name: "Login" });
      }
    }
  }
});

export default router;
